import { routes } from "../routes/Routes";

export const PRIVATE_WEALTH_ADVISOR_ROLE = "Wealth Advisor";
export const COMPLIANCE_ADMINISTRATOR_ROLE = "Compliance Administrator";
export const UNDERWRITER_BANKER_ROLE = "Underwriter Banker";
export const SENIOR_PRIVATE_BANKER_ROLE = "Senior Private Banker";
export const LOAN_OFFICER_ROLE = "LoanOfficer";
export const BANK_ADMIN_ROLE = "BankAdmin";

export const SUPER_ADMIN_ROLE_ID = 1;
export const LOAN_OFFICER_ROLE_ID = 2;
export const SENIOR_PRIVATE_BANKER_ROLE_ID = 3;
export const UNDERWRITER_BANKER_ROLE_ID = 4;
export const PRIVATE_WEALTH_ADVISOR_ROLE_ID = 5;
export const FIRM_ADMIN_ROLE_ID = 6;
export const CLIENT_ROLE_ID = 7;
export const COMPLIANCE_ADMIN_ROLE_ID = 8;

export const genderData = [
  { label: "Male", value: "Male", id: 1 },
  { label: "Female", value: "Female", id: 2 }
];
export const states = ['California', 'Oklahoma', 'Texas'];
export const trustTypes = [
  { value: 'revocable', label: 'Revocable Trust' },
  { value: 'irrevocable', label: 'Irrevocable Trust' },
];
export const mortageType = [
  { value: 'mortgage type1', label: 'mortgage type1' },
  { value: 'mortgage type2', label: 'mortgage type2' },
  { value: 'mortgage type3', label: 'mortgage type3' },
];
export const repaymentBasisOptions = [
  { value: 'Gross Repayment', label: 'Gross Repayment' },
  { value: 'Principal + After-Tax Gains', label: 'Principal + After-Tax Gains' },
  { value: 'After-Tax Gains Only', label: 'After-Tax Gains Only' },
];
export const applicationType = [
  { value: 'Borrower', label: 'Borrower' },
  { value: 'Trust', label: 'Trust' },
  { value: 'Borrower & Co-Borrower (Trust)', label: 'Borrower & Co-Borrower (Trust)' },
  { value: 'Borrower & Co-Borrower', label: 'Borrower & Co-Borrower' },
];
export const typeOfBusinessOptions = [
  { value: 'Sponsor', label: 'Sponsor' },
  { value: 'Corporate', label: 'Corporate' },
  { value: 'Law Firm', label: 'Law Firm' },
];

// export const applicationStatus = [
//   { id: 1, name: "New", buttonName: "Complete & Submit", color: "rgba(245, 158, 11, 0.10)", textColor: "#F59E0B" }, // Light Yellow / Amber
//   { id: 2, name: "Submitted", buttonName: "View Application", color: "rgba(34, 197, 94, 0.10)", textColor: "rgba(74, 222, 128, 1)" }, // Light Cyan / Teal
//   { id: 3, name: "Under Review", buttonName: "View Application", color: "#3B82F61A", textColor: "#3B82F6" }, // Light Blue / Blue
//   { id: 4, name: "Revision Requested", buttonName: "Edit & Resubmit", color: "#FFF3E0", textColor: "#EF6C00" }, // Light Orange / Orange
//   { id: 5, name: "Action Required", buttonName: "Complete & Resubmit", color: "rgba(245, 158, 11, 0.10)", textColor: "rgba(245, 158, 11, 1)" }, // Lavender / Purple
//   { id: 6, name: "Resubmitted", buttonName: "View Application", color: "#EDE7F6", textColor: "#5E35B1" }, // Pale Violet / Indigo
//   { id: 7, name: "Recommended", buttonName: "View Application", color: "#E8EAF6", textColor: "#3949AB" }, //  Light Indigo / Indigo
//   { id: 8, name: "Approved", buttonName: "View Application", color: "#F59E0B1A", textColor: "#B26A00" }, // Light Green / Green
//   { id: 9, name: "Rejected", buttonName: "View Application", color: "rgba(248, 113, 113, 0.10)", textColor: "rgba(248, 113, 113, 1)" }, // Light Pink / Red
//   { id: 10, name: "Credit Review", buttonName: "View Application", color: "#E3F2FD", textColor: "#1565C0" }, // Light Blue / Blue
//   // { id: 11, name: "Started", buttonName: "View Application", color: "#E8F5E9", textColor: "#2E7D32" }, // Light Green
//   // { id: 12, name: "Completed", buttonName: "View Application", color: "#E0F2F1", textColor: "#00695C" } // Teal
// ];

export const applicationStatus = [
  { id: 1, name: "Draft", buttonName: "Complete & Submit", color: "rgba(245, 158, 11, 0.10)", textColor: "#F59E0B" },
  { id: 2, name: "Document Upload", buttonName: "Complete & Submit", color: "rgba(245, 158, 11, 0.10)", textColor: "#EDE7F6", },
  { id: 3, name: "In Progress", buttonName: "View Application", color: "#E3F2FD", textColor: "#1565C0" },
  { id: 4, name: "Applicant Review", buttonName: "View Application", color: "#EDE7F6", textColor: "#5E35B1" },
  { id: 5, name: "Submitted", buttonName: "View Application", color: "rgba(34, 197, 94, 0.10)", textColor: "rgba(74, 222, 128, 1)" },
  { id: 6, name: "Cleared", buttonName: "View Application", color: "#E8F5E9", textColor: "#2E7D32" },
  { id: 7, name: "In Review Private Banker", buttonName: "View Application", color: "#3B82F61A", textColor: "#3B82F6" },
  { id: 8, name: "In Review Underwriter Banker", buttonName: "View Application", color: "#E8EAF6", textColor: "#3949AB" },
  { id: 9, name: "Action Required", buttonName: "Complete & Resubmit", color: "rgba(245, 158, 11, 0.10)", textColor: "rgba(245, 158, 11, 1)" },
  { id: 10, name: "Resubmitted", buttonName: "View Application", color: "#EDE7F6", textColor: "#5E35B1" },
  { id: 11, name: "Recommended", buttonName: "View Application", color: "#E8EAF6", textColor: "#3949AB" },
  { id: 12, name: "In Review Loan Officer", buttonName: "View Application", color: "#D1ECF1", textColor: "#0C5460" },
  { id: 13, name: "Approved", buttonName: "View Application", color: "#F59E0B1A", textColor: "#B26A00" },
  { id: 14, name: "Rejected", buttonName: "View Application", color: "rgba(248, 113, 113, 0.10)", textColor: "rgba(248, 113, 113, 1)" },
  { id: 15, name: "Propose", buttonName: "View Application", color: "rgba(245, 158, 11, 0.10)", textColor: "#EDE7F6", },
  { id: 16, name: "Declined", buttonName: "View Application", color: "rgba(248, 113, 113, 0.10)", textColor: "rgba(248, 113, 113, 1)" },
];


export const ScreenNamebalancesheetasset = "balancesheetasset";
export const ScreenNameDashboard = "dashboard";
export const ScreenNamebalancesheettotalasset = "balancesheettotalasset";
export const ScreenNamebalancesheetliability = "balancesheetliability";
export const UnderReviewStatusId = 7;
export const LoanOfficerReviewStatusId = 12;

export const UnderReviewPrivateBankerId = 7;
export const UnderReviewUnderwriterBanker = 8;

export const getPrivateRoutesByRole = () => ({
  client: [
    routes.ApplicantsDetails.path,
    routes.ProofOfTrust.path,
    routes.applicantsIdentification.path,
    routes.coBorrowersDetails.path,
    routes.identificationOfcoBorrower.path,
    routes.applicantProfessionalDetails.path,
    routes.uploaddocuments.path,
    routes.uploaddocumentpreview.path,
    routes.liquidity.path,
    routes.realestateassets.path,
    routes.businessAssets.path,
    routes.partnershipInterests.path,
    routes.personalHolding.path,
    routes.liabilitiesForm.path,
    routes.incomeSources.path,
    routes.expenses.path,
    routes.balanceSheetAssets.path,
    routes.balanceSheetTotalAssets.path,
    routes.balanceSheetTotalLiabilities.path,
    routes.questionnaire.path,
    routes.dashboard.path,
    routes.myApplications.path,
    routes.applicationStatus.path,
    routes.createNewPasswordForUser.path,
    // routes.liveAccountBalances.path,
    // routes.advancesAndRepayments.path,
    // routes.dataInsights.path,
    // routes.firmadminsponsersdetails,
  ],
  // banker: [
  //   routes.personalDetails.path,
  //   routes.professionalDetails.path,
  //   routes.loanapplication.path,
  //   routes.revisionrequest.path,
  //   routes.bankerdashboard.path,
  //   routes.bankerprofile.path,
  //   routes.sponsors.path,
  //   routes.addEditSponsers.path,
  //   routes.loanApplicationDetails.path,
  //   routes.createNewPasswordForBanker.path,
  //   routes.liveAccountBalancesForBanker.path,
  //   routes.advancesAndRepaymentsForBanker.path,
  //   routes.dataInsightsForBanker.path,
  //   routes.bankerReports.path,
  //   routes.newReports.path,
  // ],
  seniorPrivateBanker: [
    routes.personalDetails.path,
    routes.professionalDetails.path,
    routes.loanapplication.path,
    routes.revisionrequest.path,
    routes.bankerdashboard.path,
    routes.bankerprofile.path,
    routes.sponsors.path,
    routes.addEditSponsers.path,
    routes.facilityDetails.path,
    routes.loanApplicationDetails.path,
    routes.createNewPasswordForBanker.path,
    routes.liveAccountBalancesForBanker.path,
    routes.advancesAndRepaymentsForBanker.path,
    routes.dataInsightsForBanker.path,
    routes.bankerReports.path,
    routes.newReports.path,
    routes.seniorBankerFirmDashboard.path,
    routes.seniorBankerFacilityDetails.path,
    routes.complianceAdminSponserDetails.path,
  ],
  underwriterBanker: [
    routes.personalDetails.path,
    routes.professionalDetails.path,
    routes.loanapplication.path,
    routes.revisionrequest.path,
    routes.bankerdashboard.path,
    routes.bankerprofile.path,
    routes.loanApplicationDetails.path,
    routes.createNewPasswordForBanker.path,
    routes.liveAccountBalancesForBanker.path,
    routes.advancesAndRepaymentsForBanker.path,
    routes.dataInsightsForBanker.path,
    routes.bankerReports.path,
    routes.newReports.path,
    routes.complianceAdminFirmDashboard.path,
    routes.complianceAdminFacilityDetails.path,
    routes.complianceAdminSponserDetails.path,
  ],
  privateWealthAdvisor: [
    routes.createNewPasswordForBanker.path,
    routes.personalDetails.path,
    routes.professionalDetails.path,
    routes.bankerprofile.path,
    routes.loanapplication.path,
    routes.bankerdashboard.path,
    routes.loanApplicationDetails.path,
    // Reports Enhancement (Sept 2026), Requirement #5: Wealth Advisor previously had no access to
    // this feature at all -- new, read-only access (same assignment-scoped rows as the banker
    // roles, no action buttons).
    routes.newReports.path,
  ],
  complianceAdministrator: [
    routes.createNewPasswordForBanker.path,
    routes.personalDetails.path,
    routes.professionalDetails.path,
    routes.bankerprofile.path,
    routes.loanapplication.path,
    routes.loanApplicationDetails.path,
    routes.complianceadmindashboard.path,
    routes.loanApplicationsForComplianceAdmin.path,
    routes.liveAccountBalancesForCompliance.path,
    routes.newReports.path,
    routes.complianceAdminFirmDashboard.path,
    routes.complianceAdminFacilityDetails.path,
    routes.complianceAdminSponserDetails.path,
  ],
  loanOfficer: [
    routes.loanOfficerDashboard.path,
    routes.loanOfficerRevisionRequest.path,
    routes.loanApplicationDetails.path,
    routes.personalDetailsForLoanOfficer.path,
    routes.professionalDetailsForLoanOfficer.path,
    routes.createNewPasswordForLoanOfficer.path,
    routes.loanOfficerProfile.path,
    routes.loanApplicationsForLoanOfficer.path,
    routes.dataInsightsForBanker.path,
    routes.loanOfficerReports.path,
    routes.forgotLoanOfficerPassword,
    routes.forgotLoanOfficerLoginPasswordSendOTP,
    routes.enterEmailForLoanOfficer,
    routes.liveAccountBalancesForBanker.path,
    routes.newReports.path,
    // Shared onboarding steps for a multi-role Banker + BankerRoles account whose primary
    // role resolves to Loan Officer (lowest assigned RoleId) -- VerifyBankerRolesOtp.js always
    // routes through these generic pages regardless of primary role, then ProfessionalDetails.js
    // branches on to routes.loanOfficerDashboard.path (already in this array) once complete.
    routes.personalDetails.path,
    routes.professionalDetails.path,
    routes.createNewPasswordForBanker.path,
    routes.bankerprofile.path,
  ],
  bankadmin: [
    routes.bankadminpersonaldetails.path,
    routes.bankadminprofessionaldetails.path,
    routes.createbankadminpassword.path,
    routes.bankadmindashboard.path,
    routes.bankadminprofile.path,
    routes.bankadminverifyotp.path,
    routes.createbankadminpassword.path,
    routes.changeHistory.path,
  ],
  firmadmin: [
    routes.firmadmindashboard.path,
    routes.advancesAndRepayments.path,
    routes.firmadminsponsersdetails.path,
    routes.firmadminfacilitydetails.path,
    routes.liveAccountBalances.path,
    routes.dataInsights.path,
    routes.newReports.path,
  ]
});


export const ApplicationScreens = [
  { screenName: "Personal Details", statusKey: "IsAapplicationDetailsCompleted", url: "/applicant-details" },
  { screenName: "Proof Of Trust", statusKey: "IsProofofTrustCompleted", url: "/proof-of-trust" },
  { screenName: "Identification Details", statusKey: "IsAapplicationIdentificationCompleted", url: "/applicant-identification" },
  { screenName: "Cob Details", statusKey: "IsCoborrowerDetailsCompleted", url: "/co-BorrowersDetails" },
  { screenName: "Cob Identification", statusKey: "IsCoborrowerIdentificationCompleted", url: "/identificationOfCo-Borrower" },
  { screenName: "Document Upload", statusKey: "IsDocumentUploadCompleted", url: "/upload-documents" },
  { screenName: "Income Source", statusKey: "IsIncomesourceCompleted", url: "/income-sources" },
  { screenName: "Expenses", statusKey: "IsExpensesCompleted", url: "/expenses" },
  { screenName: "Balance Sheet Asset", statusKey: "IsBalancesheetAssetCompleted", url: "/balance-sheet-assets" },
  { screenName: "Balance Sheet Total Asset", statusKey: "IsBalancesheetTotalAssetCompleted", url: "/balance-sheet-total-assets" },
  { screenName: "Balance Sheet Total Liability", statusKey: "IsBalancesheetTotalLiabiltyCompleted", url: "/balance-sheet-total-liabilities" },
  { screenName: "Questionnaire", statusKey: "IsQuestionairCompleted", url: "/questionnaire" }
];

export const LoanProgramFunds = [
  { label: "Fund I", value: "fund1" },
  { label: "Fund II", value: "fund2" },
  { label: "Fund III", value: "fund3" },
  { label: "Fund IV", value: "fund4" },
];